export function formatDate(timestamp: string | void, splitter: string = '/') {
    if (typeof timestamp !== 'string') return '';
    const dateObj = new Date(timestamp);
    const date = `0${dateObj.getDate()}`.slice(-2);
    const month = `0${dateObj.getMonth() + 1}`.slice(-2);
    const year = dateObj.getFullYear();
    return [date, month, year].join(splitter);
}